// @flow
import type {ApplicationState} from '../../state/types'

import './PlaceSearchForm.css'
import React, {Component} from 'react'
import {connect} from 'react-redux'

import {withTranslate} from '../translation'

import {mapActions} from '../../state/map/actions'
import {mapSelectors} from '../../state/map/selectors'

type Props = {
  cities: City[],
  selectedCity: ?Url,
  onSelectedCity: Function,
  onSearchByName: Function,
  onSearchByLocation: Function,
  t: Function,
}

type State = {
  name: string,
  district: number,
}

class PlaceSearchForm extends Component<Props, State> {

  state = {
    name: '',
    district: 0,
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  handleSelectCity = (e) => {
    const {onSelectedCity} = this.props
    onSelectedCity(e.target.value) 
  }

  handleNameSearchSubmit = (e) => {
    const {onSearchByName} = this.props
    onSearchByName(this.state.name)
    e.preventDefault()
  }

  handleCitySearchSubmit = (e) => {
    const {selectedCity, onSearchByLocation} = this.props
    onSearchByLocation(selectedCity)
    e.preventDefault()
  }

  render() {
    const {cities, selectedCity, t} = this.props

    return (
      <div className="search-box">
        <form
          onSubmit={this.handleCitySearchSubmit}
          key="city-district-search-form"
          className="city-search-form"
        >
          <div className="form-label">
            <label htmlFor="city">{t('HospitalForm.city.label')}</label>
            <div className="select">
              <select 
                className="select" 
                name="city"
                onChange={this.handleSelectCity}
                value={selectedCity ? selectedCity: ''}
              >
                {cities.map((c, index) => {
                  return (
                    <option key={c.name_en} value={c._links.self}>{c.name}</option>
                  )
                })}
              </select>
            </div>
          </div>
          <button type="submit" onClick={this.handleCitySearchSubmit} className="button is-small">{t('Search.byLocation')}</button>
        </form>
        {/* <form
          onSubmit={this.handleNameSearchSubmit}
          key="name-search-form"
          className="name-search-form"
        >
          <input
            name="name"
            type="text"
            className="input"
            placeholder={t('Search.placeholder')}
            value={this.state.name}
            onChange={this.handleChange}
          />
          <button type="submit">{t('Search.byName')}</button>
        </form> */}
      </div>
    )
  }
}

const mapStateToProps = (state: ApplicationState) => {
  return {
    cities: mapSelectors.getCities(state),
    selectedCity: mapSelectors.getSelectedCity(state),
  }
}

const mapDispatchToProps = (dispatch: Function) => {
  return {
    onSelectedCity: (city) => {
      dispatch(mapActions.setSelectedCity(city))
    },
    onSearchByName: (text) => {
      dispatch(mapActions.searchByText(text))
    },
    onSearchByLocation: (city, district) => {
      dispatch(mapActions.searchByLocation(city, null))
    },
  }
}

export default withTranslate(connect(mapStateToProps, mapDispatchToProps)(PlaceSearchForm))